export default function Marquee({ items = [], theme = "main" }) {
  const dark = theme === "mini";
  const text = dark ? "text-gs-ember" : "text-gs-ember";
  const bg = dark ? "bg-gs-screen border-y border-gs-ember/30" : "bg-gs-ink border-y border-gs-ember/40 text-gs-ember";
  return (
    <div data-testid="marquee" className={`overflow-hidden ${bg}`}>
      <div className="marquee-track animate-marquee py-3">
        {[...items, ...items].map((item, i) => (
          <span
            key={`${item}-${i}`}
            className={`shrink-0 px-8 font-display text-2xl tracking-wide uppercase ${text} flex items-center gap-8`}
          >
            {item}
            <span className="opacity-50">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
